import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminSession } from "@/auth/AdminSession";
import { openTenant } from "@/auth/tenantSelection";
import ApiService from "@/services/ApiService";
import { Button } from "@/components/ui/button";
import {
  Frame,
  Panel,
  Feedback,
  LoadState,
  Pager,
  Page,
  useData,
  useMutation,
  japanDate,
} from "./ui";
type Notice = {
  id: number;
  tenant_type: "agent" | "company";
  tenant_id: number;
  read_at: string | null;
  created_at: string;
  data: {
    title: string;
    job_title?: string;
    application_id?: number;
    job_id?: number;
  };
};
export default function Notifications() {
  const [page, setPage] = useState(1);
  const result = useData<{ unread: number; notifications: Page<Notice> }>(
    "notifications",
    { page },
  );
  const op = useMutation();
  const { session } = useAdminSession();
  const navigate = useNavigate();
  const open = async (n: Notice) => {
    if (
      !n.read_at &&
      !(await op.run(
        () => ApiService.post("notifications/" + n.id + "/read", {}),
        "既読にしました。",
      ))
    )
      return;
    result.reload();
    const membership = session.memberships.find(
      (m) => m.type === n.tenant_type && m.id === n.tenant_id,
    );
    const path = n.data.application_id
      ? "/job-applications/" + n.data.application_id
      : n.data.job_id
        ? "/jobs/" + n.data.job_id
        : "/";
    if (membership)
      openTenant({ ...membership, actorId: session.user.id }, path);
    else if (session.is_platform_admin) navigate("/platform");
  };
  return (
    <Frame
      title="通知"
      description={"未読 " + (result.data?.unread ?? 0) + "件"}
    >
      <Feedback {...op} />
      <Panel>
        <LoadState {...result} />
        {result.data?.notifications.data.map((n) => (
          <article
            key={n.id}
            className={
              "border-b py-4 flex flex-wrap items-center justify-between gap-3 " +
              (!n.read_at ? "font-semibold" : "")
            }
          >
            <div>
              <h2>
                {!n.read_at && "● "}
                {n.data.title}
              </h2>
              <p className="text-sm">{n.data.job_title}</p>
              <p className="text-xs text-muted-foreground">
                {japanDate(n.created_at)}
              </p>
            </div>
            <Button
              variant="outline"
              disabled={op.busy}
              onClick={() => open(n)}
            >
              確認
            </Button>
          </article>
        ))}
        {result.data && !result.data.notifications.data.length && (
          <p>通知はありません。</p>
        )}
        {result.data && (
          <Pager result={result.data.notifications} setPage={setPage} />
        )}
      </Panel>
    </Frame>
  );
}
